<template>
    <div>
        <div v-if="fetching" class="flex justify-center items-center">
            <loading />
        </div>
        <MultiPostingDiscoverListItem v-else-if="!hasMultiPostingSubscription"
            :title="$t('multi-posting.discover.contracts.title')"
            :description="$t('multi-posting.discover.contracts.description')" />
        <MultiPostingEmptyListItem v-else-if="!contracts.length && (!contractGroups.length || contractGroups.length === 1)" :title="$t('multi-posting.contracts.empty.title')"
            :description="$t('multi-posting.contracts.empty.description')"
            :buttonLabel="$t('multi-posting.tabs.contracts.add')"
            :loading="creating"
            @onClick="$emit('update:creating', true)"
        />
        <div v-else>
            <draggable
                handle=".draggable"
                v-model="contractGroups"
                item-key="id"
                class="mb-32"
                @start="dragStart"
            >
                <template #item="{ element }">
                    <ContractListGroup
                        :contracts="contracts"
                        :group="element"
                        class="bg-white rounded pl-4 pr-4 pb-4"
                        @contract-removed="contractRemoved"
                        @change-tab="$emit('change-tab', {tab: 'Campaigns', params: 'create'})"
                        :data-group-id="element.id"
                    />
                </template>
            </draggable>
        </div>
    </div>
</template>

<script>
import * as Vonq from "/../../vendor/jobtoolz/vonq/public/js/share/Vonq.js"
import ContractListGroup from "./ContractListGroup.vue";
import MultiPostingDiscoverListItem from "./MultiPostingDiscoverListItem.vue";
import MultiPostingEmptyListItem from "./MultiPostingEmptyListItem.vue";
import Loading from "../ui/Loading.vue";
import { mapActions, mapState, mapStores } from "pinia";
import {useMainStore} from '../../state/store';
import {useMultiPostingStore} from '../../state/modules/multiPosting';
import {useNotificationsStore} from '../../state/modules/notifications';
import { ADD_NOTIFICATION } from "../../state/mutation-types";
import { filter } from "lodash";
import draggable from 'vuedraggable';

// VUE3_MIGRATION - temp fix for vuedraggable, compat issue
draggable.compatConfig = { MODE: 3 }

export default {
    name: 'ContractList',
    components: {
        Loading,
        MultiPostingEmptyListItem,
        MultiPostingDiscoverListItem,
        ContractListGroup,
        draggable,
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany', 'currentUser']),
        ...mapStores(useMultiPostingStore),
        contractGroups: {
            get() {
                return this.multiPostingStore.contractGroups;
            },
            set(value) {
                const contractGroupsPrevious = _.cloneDeep(this.contractGroups);
                const contractGroupsRequestItems = value.map((item, index) => ({ ...item, position: index }));
                const groupName = this.lastItemDragged.name;
                this.multiPostingStore.SET_CONTRACT_GROUPS(contractGroupsRequestItems);
                this.moveContractGroups(
                  {
                    groups: contractGroupsRequestItems
                  }
                ).then(() => {
                    this[ADD_NOTIFICATION](
                        {
                            type: 'success',
                            message: this.$t('multi-posting.contracts.groups.group.sort.group.success', { group: groupName }),
                        }
                    );
                }
                ).catch(() => {
                    this.multiPostingStore.SET_CONTRACT_GROUPS(contractGroupsPrevious);
                    this[ADD_NOTIFICATION](
                        {
                            type: 'error',
                            message: this.$t('multi-posting.contracts.groups.group.sort.group.error', { group: groupName }),
                        }
                    );
                });
            }
        },
    },
    data: function () {
        return {
            fetching: false,
            contracts: [],
            lastItemDragged: "",
        }
    },
    props: {
        hasMultiPostingSubscription: {
            type: Boolean,
            default: false,
        },
        creating: {
            type: Boolean,
            default: false,
        }
    },

    methods: {
        ...mapActions(useMultiPostingStore, ['moveContractGroups']),
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        getContracts() {
            if (!this.hasMultiPostingSubscription) return;
            this.fetching = true;
            Vonq.api({
                action: "getContracts",
                includeExtra: false,
                userId: this.currentCompany.id
            })
                .then((contracts) => this.contracts = contracts)
                .then(() => this.fetching = false);
        },
        contractRemoved(id) {
            this.contracts = filter(this.contracts, contract => contract.contract_id !== id);
        },
        dragStart(event) {
            this.lastItemDragged = this.contractGroups.find((group) => group.id === event.item.getAttribute('data-group-id'));
        },
    },
    mounted() {
        this.getContracts();
    }
}
</script>
